(function () {
  'use strict';

  angular.module('app').component('bookingItemInfo', bookingItemInfo());

  function bookingItemInfo() {
    return {
      bindings: {
        bookingItem: '<',
        bookingItemServiceItem: '<',
        booking: '<',
      },
      controller: BookingItemInfoComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/components/' +
        'booking-item-info/booking-item-info.component.html',
    };
  }

  BookingItemInfoComponent.$inject = ['CONFIGURATIONS', 'BookingService'];

  function BookingItemInfoComponent(config, BookingService) {
    let vm = this;

    vm.dateDisplay = config.DATE_DISPLAY; // month day, year
    vm.hourDisplay = config.HOUR_DISPLAY; // hh:mm a

    vm.$onInit = function () {
      if (!vm.bookingItemServiceItem) {
        vm.bookingItemData = vm.bookingItem;
        vm.bookingItemDataNumber = vm.bookingItemData.booking_item_number;
        vm.bookingItemDataServiceName = vm.bookingItemData.detail.name;
      } else {
        vm.bookingItemData = vm.bookingItemServiceItem;
        vm.bookingItemDataNumber = vm.bookingItemData.booking_item_service_item_number;
        vm.bookingItemDataServiceName = vm.bookingItemData.service_item.name;
      }

      vm.bookingCurrency = vm.booking.currency;

      vm.totalPax = BookingService.getTotalPax(
        vm.bookingItemData.adults,
        vm.bookingItemData.children,
        vm.bookingItemData.infants,
        vm.bookingItemData.seniors
      );
    };
  }
})();
